import { APP_ROUTES } from 'constants/routes';
import { uuidSegmentUnder } from 'utils/uuidPathSegment';

/**
 * The staged-order `refId` a `/orders/staged-orders/<segment>` URL names, or
 * `null` for anything else — a dealer scope (`all`, `jetfresh`, `cw-order`),
 * an unported sub-page, a typo. Shape-decided inside the staged splat, the
 * same way `orderRefIdFromSalesOrdersPath` serves sales orders: a
 * `:orderId` route would outrank the splat and send every unrecognised
 * segment to the detail page's "failed to load" state instead of Coming Soon.
 */
export function stagedOrderRefIdFromPath(pathname: string): string | null {
  return uuidSegmentUnder(APP_ROUTES.stagedOrdersBase, pathname);
}
